export default {"src":"/_next/static/media/Cardiovascular Diseases.adbb1d45.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};